import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import auth from "../store/modules/Auth.js"
import settings from "../store/modules/Settings.js"
import updates from "../store/modules/Updates.js"


export default new Vuex.Store({
	modules: {auth, settings, updates},
	mutations: {},
	actions: {
	},
})

